import script from "./AddCustomerServices.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCustomerServices.vue?vue&type=script&setup=true&lang=js"

import "./AddCustomerServices.vue?vue&type=style&index=0&id=b6ac35a2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b6ac35a2"]])

export default __exports__